import { subDays, format, compareAsc, isDate, toDate, parseISO } from 'date-fns'

export function formatHtmlDateInput(d) {
    const value = new Date(d)

    return format(value, 'yyyy-MM-dd')
}

export function isValidDateRange({ start, end }) {
    return compareAsc(end, start) === -1 ? false : true
}

export function isSameDate({ left, right }) {
    return compareAsc(left, right) === 0 ? true : false
}

export function getToday() {
    return new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
    )
}

export function formatForTimezone(date, dateFormat){
	const dt = date instanceof Date ? date : new Date(date);
	const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
	return format(dtDateOnly, dateFormat)
}